(function () {
  'use strict';

  var browserWindow = typeof window !== 'undefined' ? window : null;
  var shared = browserWindow ? (browserWindow.PBNPaintPickerCache = browserWindow.PBNPaintPickerCache || {}) : {};

  var STRINGS = {
    fi: {
      pickerTitle: 'Valitse tarvitsemasi maalit',
      pickerIntro: 'Hae yksittäisiä värikoodeja tai tilaa koko maalauksen värisetti.',
      tabListLabel: 'Maalien tilaustapa',
      tabColors: 'Yksittäiset värit',
      tabSet: 'Koko maalauksen värit',
      selectedTitle: 'Valitut maalit',
      selectedEmpty: 'Ei vielä valintoja.',
      clearSelection: 'Tyhjennä valinnat',
      searchLabel: 'Hae maalikoodilla',
      searchPlaceholder: 'Esim. A2584 tai B010',
      clearSearch: 'Tyhjennä',
      filterSummary: 'Rajaa väriperheen mukaan',
      screenNote: 'Näytön sävy on suuntaa-antava',
      loadingColors: 'Ladataan väripalettia…',
      loadingPaintings: 'Ladataan maalauksia…',
      addColors: 'Lisää valitut ostoskoriin',
      adding: 'Lisätään ostoskoriin…',
      added: 'Maalit lisättiin ostoskoriin.',
      loadError: 'Väripalettia ei voitu ladata. Yritä hetken kuluttua uudelleen.',
      cartError: 'Maaleja ei voitu lisätä ostoskoriin. Yritä uudelleen.',
      priceVariantMissing: 'Valitulle kuppimäärälle ei löytynyt hintaa. Päivitä sivu ja yritä uudelleen.',
      setProductMissing: 'Valitulle värisetille ei löytynyt hintaa. Päivitä sivu ja yritä uudelleen.',
      maxPots: 'Voit tilata valitsimella enintään {count} yksittäistä kuppia kerralla.',
      setTitle: 'Tilaa kaikki maalauksen värit kerralla',
      setIntro: 'Hae maalausta nimellä tai tuotekoodilla. Tuotekoodi löytyy myös pakkauksesta ja värilistasta.',
      paintingLabel: 'Maalauksen nimi tai tuotekoodi',
      paintingPlaceholder: 'Esim. Mountain Serenity tai NMT-32',
      setCompatibility: 'Koko setti vastaa paintbynumbers.fi-maalauksen alkuperäisiä värikoodeja.',
      setPriceRule: 'Pakettihinta on yksittäin ostettavia kuppeja edullisempi.',
      addSet: 'Lisää koko värisetti ostoskoriin',
      setEmpty: 'Hae maalausta nimellä tai tuotekoodilla nähdäksesi värisetin.',
      noPainting: 'Maalausta ei löytynyt. Tarkista nimi tai tuotekoodi.',
      all: 'Kaikki', red: 'Punaiset', orange: 'Oranssit ja ruskeat', yellow: 'Keltaiset ja beiget', green: 'Vihreät', blue: 'Siniset ja turkoosit', purple: 'Violetit', pink: 'Roosat', neutral: 'Neutraalit',
      cupOne: '1 kuppi', cups: '{count} kuppia', resultOne: '1 värikoodi', results: '{count} värikoodia', colors: '{count} väriä · {count} × 3 ml',
      selectColor: 'Valitse värikoodi {code}', decrease: 'Vähennä värin {code} määrää', increase: 'Lisää värin {code} määrää',
      visibleModeKey: 'Tilaustapa', modeSingle: 'Yksittäiset maalit', modeSet: 'Koko maalauksen värisetti', paintingKey: 'Maalauksen SKU', setCountKey: 'Värikuppien määrä', paintsKey: 'Maalit'
    },
    en: {
      pickerTitle: 'Choose the paints you need',
      pickerIntro: 'Search individual colour codes or order the complete paint set for a painting.',
      tabListLabel: 'Paint order type',
      tabColors: 'Individual colours',
      tabSet: 'Complete paint set',
      selectedTitle: 'Selected paints',
      selectedEmpty: 'No selections yet.',
      clearSelection: 'Clear selections',
      searchLabel: 'Search by paint code',
      searchPlaceholder: 'For example A2584 or B010',
      clearSearch: 'Clear',
      filterSummary: 'Filter by colour family',
      screenNote: 'On-screen colours are indicative',
      loadingColors: 'Loading colour palette…',
      loadingPaintings: 'Loading paintings…',
      addColors: 'Add selected paints to cart',
      adding: 'Adding to cart…',
      added: 'The paints were added to the cart.',
      loadError: 'The colour palette could not be loaded. Please try again shortly.',
      cartError: 'The paints could not be added to the cart. Please try again.',
      priceVariantMissing: 'Pricing could not be found for the selected number of pots. Refresh the page and try again.',
      setProductMissing: 'Pricing could not be found for the selected paint set. Refresh the page and try again.',
      maxPots: 'You can order up to {count} individual pots at a time with the selector.',
      setTitle: 'Order every colour for a painting at once',
      setIntro: 'Search by painting name or product code. The code is also shown on the package and colour list.',
      paintingLabel: 'Painting name or product code',
      paintingPlaceholder: 'For example Mountain Serenity or NMT-32',
      setCompatibility: 'The complete set matches the original colour codes of a paintbynumbers.eu painting.',
      setPriceRule: 'The package price is lower than buying the pots individually.',
      addSet: 'Add complete paint set to cart',
      setEmpty: 'Search by painting name or product code to see its paint set.',
      noPainting: 'Painting not found. Check the name or product code.',
      all: 'All', red: 'Reds', orange: 'Oranges and browns', yellow: 'Yellows and beiges', green: 'Greens', blue: 'Blues and teals', purple: 'Purples', pink: 'Pinks', neutral: 'Neutrals',
      cupOne: '1 pot', cups: '{count} pots', resultOne: '1 colour code', results: '{count} colour codes', colors: '{count} colours · {count} × 3 ml',
      selectColor: 'Select colour code {code}', decrease: 'Decrease quantity for colour {code}', increase: 'Increase quantity for colour {code}',
      visibleModeKey: 'Selection', modeSingle: 'Individual paints', modeSet: 'Complete paint set', paintingKey: 'Painting SKU', setCountKey: 'Number of paint pots', paintsKey: 'Paints'
    }
  };

  var FAMILY_ORDER = ['all', 'red', 'orange', 'yellow', 'green', 'blue', 'purple', 'pink', 'neutral'];
  var FAMILY_DOTS = {
    all: 'linear-gradient(135deg, #c84f4b 0 25%, #d5a13c 25% 50%, #4d9272 50% 75%, #5c73a8 75%)',
    red: '#c84f4b',
    orange: '#b96f3f',
    yellow: '#d5a13c',
    green: '#4d9272',
    blue: '#5c73a8',
    purple: '#7b5aa6',
    pink: '#c8758f',
    neutral: '#8a837e'
  };

  function normalize(value) {
    return String(value || '').trim().toUpperCase().replace(/\s+/g, '');
  }

  function normalizePaintingCode(value) {
    return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function normalizePaintingText(value) {
    var text = String(value || '').trim();
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text.toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }

  function canonicalDigits(value) {
    return String(value || '').replace(/^0+(?=\d)/, '');
  }

  function paintCodeParts(value) {
    var code = normalize(value);
    var match = code.match(/^([A-Z]+)(\d+)$/);
    if (!match) return null;
    return { code: code, prefix: match[1], digits: match[2], numeric: canonicalDigits(match[2]) };
  }

  function paintSearchScore(color, value) {
    var query = normalize(value);
    if (!query) return 0;

    var parts = color.prefix ? color : paintCodeParts(color.code);
    if (!parts) return -1;

    if (/^\d+$/.test(query)) {
      var numericQuery = canonicalDigits(query);
      if (parts.numeric === numericQuery) return 0;
      if (parts.numeric.indexOf(numericQuery) === 0) return 1;
      return parts.numeric.indexOf(numericQuery) >= 0 ? 2 : -1;
    }

    var queryParts = paintCodeParts(query);
    if (queryParts) {
      if (parts.prefix !== queryParts.prefix) return -1;
      if (parts.numeric === queryParts.numeric) return 0;
      if (parts.numeric.indexOf(queryParts.numeric) === 0) return 1;
      return parts.numeric.indexOf(queryParts.numeric) >= 0 ? 2 : -1;
    }

    if (parts.code.indexOf(query) === 0) return 1;
    return parts.code.indexOf(query) >= 0 ? 2 : -1;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character];
    });
  }

  function buildLineItemProperties(entries, labels, mode, paintingCode, variant) {
    var total = entries.reduce(function (sum, entry) { return sum + entry[1]; }, 0);
    var properties = {};
    if (mode === 'set') {
      properties[labels.paintingKey] = paintingCode;
    } else {
      properties[labels.modeKey] = labels.modeValue;
      properties[labels.countKey] = total;
      var tokens = entries.filter(function (entry) { return entry[1] > 0; }).map(function (entry) {
        return entry[0] + ' × ' + entry[1];
      });
      var chunks = [];
      var current = '';
      tokens.forEach(function (token) {
        var next = current ? current + ', ' + token : token;
        if (current && next.length > 180) {
          chunks.push(current);
          current = token;
        } else current = next;
      });
      if (current) chunks.push(current);
      chunks.forEach(function (value, index) {
        properties[labels.paintsKey + (chunks.length > 1 ? ' ' + (index + 1) : '')] = value;
      });
      properties._pbn_paid_pots = total;
    }
    properties._pbn_pricing_version = 'variant-v1';
    properties._pbn_picker_mode = mode;
    properties._pbn_paid_variant_sku = variant.sku;
    return properties;
  }

  function rgbToHsl(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var light = (max + min) / 2;
    if (max === min) return { h: 0, s: 0, l: light };
    var delta = max - min;
    var saturation = light > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    var hue;
    if (max === r) hue = ((g - b) / delta + (g < b ? 6 : 0)) * 60;
    else if (max === g) hue = ((b - r) / delta + 2) * 60;
    else hue = ((r - g) / delta + 4) * 60;
    return { h: hue, s: saturation, l: light };
  }

  function colorFamily(hsl) {
    if (hsl.s < 0.12) return 'neutral';
    if (hsl.h < 18 || hsl.h >= 345) return 'red';
    if (hsl.h < 45) return 'orange';
    if (hsl.h < 75) return 'yellow';
    if (hsl.h < 168) return 'green';
    if (hsl.h < 245) return 'blue';
    if (hsl.h < 315) return 'purple';
    return 'pink';
  }

  function luminance(rgb) {
    var channels = rgb.map(function (value) {
      value /= 255;
      return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
  }

  function foregroundFor(rgb) {
    var background = luminance(rgb);
    var whiteContrast = 1.05 / (background + 0.05);
    var blackContrast = (background + 0.05) / 0.05;
    return whiteContrast >= blackContrast ? '#fff' : '#000';
  }

  function rgbString(color) {
    return 'rgb(' + color.rgb.join(',') + ')';
  }

  function loadJson(url, cacheKey) {
    if (!shared[cacheKey]) {
      shared[cacheKey] = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      }).catch(function (error) {
        delete shared[cacheKey];
        throw error;
      });
    }
    return shared[cacheKey];
  }

  function sampoJsTexts(area) {
    // a third language's texts, printed by the theme (snippets/sampo-js-texts) only outside fi and en
    try {
      var el = document.querySelector('script[data-sampo-js-texts="' + area + '"]');
      var own = el ? JSON.parse(el.textContent || 'null') : null;
      return own && typeof own === 'object' ? own : null;
    } catch (error) {
      return null;
    }
  }

  function init(root) {
    if (root.dataset.pbnInitialized === 'true') return;
    root.dataset.pbnInitialized = 'true';

    var locale = root.dataset.locale && root.dataset.locale.indexOf('fi') === 0 ? 'fi' : 'en';
    // a third language (Swedish pilot B1): its texts lie over English, never Finnish
    var own = sampoJsTexts('picker');
    var copy = own ? Object.assign({}, STRINGS.en, own) : STRINGS[locale];
    var currency = root.dataset.currency || 'EUR';
    var pricingVariants = [];
    try {
      pricingVariants = JSON.parse(root.querySelector('[data-pbn-pricing-variants]').textContent || '[]');
    } catch (error) {
      console.error('[PBN paint picker] pricing variants are invalid', error);
    }
    var individualVariants = new Map();
    var setTiers = [];
    pricingVariants.forEach(function (variant) {
      var individualMatch = String(variant.sku || '').match(/^PBN-PAINT-CUPS-(\d{3})$/);
      var setMatch = String(variant.sku || '').match(/^PBN-PAINT-SET-(\d+)$/);
      if (individualMatch) {
        individualVariants.set(Number(individualMatch[1]), { id: String(variant.id), price: Number(variant.price), sku: variant.sku });
      } else if (setMatch) {
        setTiers.push({ limit: Number(setMatch[1]), id: String(variant.id), price: Number(variant.price), sku: variant.sku });
      }
    });
    setTiers.sort(function (a, b) { return a.limit - b.limit; });
    var maxIndividualPots = Math.max.apply(null, Array.from(individualVariants.keys()).concat([0]));
    var palette = [];
    var paletteByCode = new Map();
    var paintings = [];
    var selected = new Map();
    var activeFamily = 'all';
    var searchTerm = '';
    var activePainting = null;
    var paletteLoaded = false;
    var paintingsLoaded = false;
    var activeSuggestionIndex = -1;

    function text(key, replacements) {
      var value = copy[key] || key;
      Object.keys(replacements || {}).forEach(function (name) {
        value = value.split('{' + name + '}').join(replacements[name]);
      });
      return value;
    }

    function applyLanguage() {
      root.querySelectorAll('[data-pbn-i18n]').forEach(function (element) {
        element.textContent = text(element.dataset.pbnI18n);
      });
      root.querySelectorAll('[data-pbn-i18n-placeholder]').forEach(function (element) {
        element.placeholder = text(element.dataset.pbnI18nPlaceholder);
      });
      root.querySelectorAll('[data-pbn-i18n-aria]').forEach(function (element) {
        element.setAttribute('aria-label', text(element.dataset.pbnI18nAria));
      });
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat(own && own.intlLocale ? own.intlLocale : locale === 'fi' ? 'fi-FI' : 'en-IE', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    }

    function priceFor(total) {
      var variant = individualVariants.get(total);
      return variant ? variant.price : 0;
    }

    function individualVariantFor(total) {
      return individualVariants.get(total) || null;
    }

    function setTierFor(total) {
      return setTiers.find(function (tier) { return total <= tier.limit; }) || null;
    }

    function totalPots(map) {
      var total = 0;
      map.forEach(function (quantity) { total += quantity; });
      return total;
    }

    function potsLabel(count) {
      return count === 1 ? text('cupOne') : text('cups', { count: count });
    }

    function setStatus(message, isError) {
      var status = root.querySelector('[data-pbn-status]');
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
      status.hidden = !message;
    }

    function normalizePalette(raw) {
      return Object.entries(raw || {}).map(function (entry) {
        var code = normalize(entry[0]);
        var parts = paintCodeParts(code);
        var rgb = entry[1];
        if (!parts || !Array.isArray(rgb) || rgb.length !== 3 || rgb.some(function (value) { return !Number.isFinite(value); })) return null;
        var hsl = rgbToHsl(rgb);
        return { code: code, prefix: parts.prefix, digits: parts.digits, numeric: parts.numeric, rgb: rgb, family: colorFamily(hsl), h: hsl.h, l: hsl.l };
      }).filter(Boolean).sort(function (a, b) {
        var familyA = FAMILY_ORDER.indexOf(a.family);
        var familyB = FAMILY_ORDER.indexOf(b.family);
        return familyA - familyB || a.h - b.h || b.l - a.l || a.code.localeCompare(b.code);
      });
    }

    function renderFilters() {
      root.querySelector('[data-pbn-filters]').innerHTML = FAMILY_ORDER.map(function (family) {
        return '<button type="button" class="pbn-paint-picker__filter" data-pbn-family="' + family + '" aria-pressed="' + (family === activeFamily) + '"><span class="pbn-paint-picker__filter-dot" aria-hidden="true" style="background:' + FAMILY_DOTS[family] + '"></span><span>' + text(family) + '</span></button>';
      }).join('');
    }

    function filteredPalette() {
      var query = normalize(searchTerm);
      return palette.map(function (color, index) {
        return { color: color, index: index, score: paintSearchScore(color, query) };
      }).filter(function (result) {
        var color = result.color;
        if (activeFamily !== 'all' && color.family !== activeFamily) return false;
        return result.score >= 0;
      }).sort(function (a, b) {
        return a.score - b.score || a.index - b.index;
      }).map(function (result) { return result.color; });
    }

    function renderPalette() {
      if (!paletteLoaded) return;
      var matches = filteredPalette();
      var grid = root.querySelector('[data-pbn-color-grid]');
      var currentTabStop = grid.querySelector('[data-pbn-color][tabindex="0"]');
      var currentCode = currentTabStop ? currentTabStop.dataset.pbnColor : '';
      grid.innerHTML = matches.map(function (color) {
        return '<button type="button" class="pbn-paint-picker__swatch" data-pbn-color="' + color.code + '" aria-pressed="' + selected.has(color.code) + '" aria-label="' + text('selectColor', { code: color.code }) + '" tabindex="-1" style="background:' + rgbString(color) + ';color:' + foregroundFor(color.rgb) + '">' + color.code + '</button>';
      }).join('');
      var swatches = Array.from(grid.querySelectorAll('[data-pbn-color]'));
      var tabStop = swatches.find(function (swatch) { return swatch.dataset.pbnColor === currentCode; }) || swatches[0];
      if (tabStop) tabStop.tabIndex = 0;
      root.querySelector('[data-pbn-results-count]').textContent = matches.length === 1 ? text('resultOne') : text('results', { count: matches.length });
    }

    function updatePaletteSelection(code) {
      if (!paletteLoaded) return;
      root.querySelectorAll('[data-pbn-color]').forEach(function (swatch) {
        if (!code || swatch.dataset.pbnColor === code) {
          swatch.setAttribute('aria-pressed', String(selected.has(swatch.dataset.pbnColor)));
        }
      });
    }

    function setSwatchTabStop(swatch) {
      root.querySelectorAll('[data-pbn-color][tabindex="0"]').forEach(function (item) { item.tabIndex = -1; });
      swatch.tabIndex = 0;
    }

    function renderSelected() {
      var grid = root.querySelector('[data-pbn-selected-grid]');
      var empty = root.querySelector('[data-pbn-selection-empty]');
      var clear = root.querySelector('[data-pbn-clear-selection]');
      var items = Array.from(selected.entries());
      var total = totalPots(selected);
      grid.hidden = items.length === 0;
      empty.hidden = items.length > 0;
      clear.hidden = items.length === 0;
      grid.innerHTML = items.map(function (entry) {
        var code = entry[0];
        var quantity = entry[1];
        var color = paletteByCode.get(code);
        return '<div class="pbn-paint-picker__selected-item">' +
          '<span class="pbn-paint-picker__selected-swatch" style="background:' + rgbString(color) + '" aria-hidden="true"></span>' +
          '<strong class="pbn-paint-picker__selected-code">' + code + '</strong>' +
          '<span class="pbn-paint-picker__quantity"><button type="button" data-pbn-quantity="minus" data-pbn-code="' + code + '" aria-label="' + text('decrease', { code: code }) + '">−</button><span>' + quantity + '</span><button type="button" data-pbn-quantity="plus" data-pbn-code="' + code + '" aria-label="' + text('increase', { code: code }) + '">+</button></span>' +
          '</div>';
      }).join('');
      root.querySelector('[data-pbn-selection-count]').textContent = potsLabel(total);
      root.querySelector('[data-pbn-selection-price]').textContent = formatMoney(priceFor(total));
      root.querySelector('[data-pbn-action-count]').textContent = potsLabel(total);
      root.querySelector('[data-pbn-action-price]').textContent = formatMoney(priceFor(total));
      var addButton = root.querySelector('[data-pbn-add-colors]');
      addButton.disabled = total === 0 || !individualVariantFor(total);
    }

    function loadPalette() {
      if (paletteLoaded) return Promise.resolve(palette);
      return loadJson(root.dataset.colorsUrl, 'colors').then(function (raw) {
        palette = normalizePalette(raw);
        paletteByCode = new Map(palette.map(function (color) { return [color.code, color]; }));
        paletteLoaded = true;
        root.querySelector('[data-pbn-palette-loading]').hidden = true;
        root.querySelector('[data-pbn-color-grid]').hidden = false;
        renderFilters();
        renderPalette();
        renderSelected();
        return palette;
      }).catch(function (error) {
        console.error('[PBN paint picker] palette load failed', error);
        root.querySelector('[data-pbn-palette-loading]').textContent = text('loadError');
        setStatus(text('loadError'), true);
        throw error;
      });
    }

    function normalizePaintings(raw) {
      return (Array.isArray(raw) ? raw : []).map(function (item) {
        var code = normalizePaintingCode(item.sku || item.name);
        if (!code || code === 'A-HYLLY' || !Array.isArray(item.colors)) return null;
        var colors = Array.from(new Set(item.colors.map(normalize))).filter(function (colorCode) { return paletteByCode.has(colorCode); });
        if (!colors.length) return null;
        var aliases = [code, item.name, item.sku, item.title].concat(item.aliases || []).filter(Boolean).map(normalizePaintingText);
        return { code: code, title: item.title || '', titleSearch: normalizePaintingText(item.title), aliases: Array.from(new Set(aliases)), colors: colors };
      }).filter(Boolean);
    }

    function findPainting(value) {
      var codeQuery = normalizePaintingCode(value);
      var codeMatch = paintings.find(function (painting) { return painting.code === codeQuery; });
      if (codeMatch) return codeMatch;
      var textQuery = normalizePaintingText(value);
      if (!textQuery) return null;
      var exactMatches = paintings.filter(function (painting) {
        return painting.aliases.some(function (alias) { return alias === textQuery; });
      });
      return exactMatches.length === 1 ? exactMatches[0] : null;
    }

    function paintingSearchScore(painting, value) {
      var textQuery = normalizePaintingText(value);
      var codeQuery = normalizePaintingCode(value);
      if (!textQuery && !codeQuery) return -1;
      if (painting.code === codeQuery) return 0;
      if (painting.titleSearch && painting.titleSearch === textQuery) return 1;
      if (painting.aliases.some(function (alias) { return alias === textQuery; })) return 2;
      if (painting.code.indexOf(codeQuery) === 0 && codeQuery) return 3;
      if (painting.titleSearch && painting.titleSearch.indexOf(textQuery) === 0) return 4;
      if (painting.aliases.some(function (alias) { return alias.indexOf(textQuery) === 0; })) return 5;
      if (painting.titleSearch && painting.titleSearch.indexOf(textQuery) >= 0) return 6;
      if (painting.aliases.some(function (alias) { return alias.indexOf(textQuery) >= 0; })) return 7;
      return -1;
    }

    function renderPainting(painting) {
      var result = root.querySelector('[data-pbn-set-result]');
      var empty = root.querySelector('[data-pbn-set-empty]');
      var add = root.querySelector('[data-pbn-add-set]');
      activePainting = painting || null;
      if (!painting) {
        result.hidden = true;
        empty.hidden = false;
        add.disabled = true;
        return;
      }
      var count = painting.colors.length;
      var tier = setTierFor(count);
      result.hidden = false;
      empty.hidden = true;
      root.querySelector('[data-pbn-set-code]').textContent = painting.code + (painting.title ? ' · ' + painting.title : '');
      root.querySelector('[data-pbn-set-price]').textContent = tier ? formatMoney(tier.price) : '';
      root.querySelector('[data-pbn-set-price-note]').textContent = tier ? text('setPriceRule') : '';
      root.querySelector('[data-pbn-set-swatches]').innerHTML = painting.colors.map(function (code) {
        var color = paletteByCode.get(code);
        return '<span class="pbn-paint-picker__set-swatch" style="background:' + rgbString(color) + ';color:' + foregroundFor(color.rgb) + '">' + code + '</span>';
      }).join('');
      add.disabled = !tier || !tier.id;
    }

    function suggestionOptions() {
      return Array.from(root.querySelectorAll('[data-pbn-painting-option]'));
    }

    function hideSuggestions() {
      var box = root.querySelector('[data-pbn-painting-suggestions]');
      var input = root.querySelector('[data-pbn-painting-search]');
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeSuggestionIndex = -1;
    }

    function setActiveSuggestion(index) {
      var options = suggestionOptions();
      var input = root.querySelector('[data-pbn-painting-search]');
      if (!options.length) {
        hideSuggestions();
        return;
      }
      activeSuggestionIndex = Math.max(0, Math.min(index, options.length - 1));
      options.forEach(function (option, optionIndex) {
        option.setAttribute('aria-selected', String(optionIndex === activeSuggestionIndex));
      });
      input.setAttribute('aria-activedescendant', options[activeSuggestionIndex].id);
      options[activeSuggestionIndex].scrollIntoView({ block: 'nearest' });
    }

    function selectPaintingOption(code) {
      var input = root.querySelector('[data-pbn-painting-search]');
      input.value = code;
      hideSuggestions();
      renderPainting(findPainting(code));
    }

    function renderSuggestions(value) {
      var box = root.querySelector('[data-pbn-painting-suggestions]');
      var input = root.querySelector('[data-pbn-painting-search]');
      var query = normalizePaintingText(value);
      if (!query || findPainting(value)) {
        hideSuggestions();
        return 0;
      }
      var matches = paintings.map(function (painting, index) {
        return { painting: painting, index: index, score: paintingSearchScore(painting, value) };
      }).filter(function (match) {
        return match.score >= 0;
      }).sort(function (a, b) {
        return a.score - b.score || a.index - b.index;
      }).slice(0, 8).map(function (match) {
        return match.painting;
      });
      box.innerHTML = matches.map(function (painting, index) {
        var title = painting.title ? '<strong>' + escapeHtml(painting.title) + '</strong><span>' + painting.code + '</span>' : '<strong>' + painting.code + '</strong>';
        return '<button type="button" class="pbn-paint-picker__suggestion" id="' + root.id + '-painting-option-' + index + '" role="option" aria-selected="false" tabindex="-1" data-pbn-painting-option="' + painting.code + '">' + title + '</button>';
      }).join('');
      box.hidden = matches.length === 0;
      input.setAttribute('aria-expanded', String(matches.length > 0));
      input.removeAttribute('aria-activedescendant');
      activeSuggestionIndex = -1;
      return matches.length;
    }

    function loadPaintings() {
      if (paintingsLoaded) return Promise.resolve(paintings);
      var loading = root.querySelector('[data-pbn-paintings-loading]');
      loading.hidden = false;
      return loadPalette().then(function () {
        return loadJson(root.dataset.paintingsUrl, 'paintings');
      }).then(function (raw) {
        paintings = normalizePaintings(raw);
        paintingsLoaded = true;
        loading.hidden = true;
        renderPainting(findPainting(root.querySelector('[data-pbn-painting-search]').value));
        return paintings;
      }).catch(function (error) {
        console.error('[PBN paint picker] paintings load failed', error);
        loading.hidden = false;
        loading.textContent = text('loadError');
        setStatus(text('loadError'), true);
        throw error;
      });
    }

    function paintProperties(map, mode, paintingCode, variant) {
      return buildLineItemProperties(Array.from(map.entries()), {
        modeKey: text('visibleModeKey'),
        modeValue: mode === 'set' ? text('modeSet') : text('modeSingle'),
        countKey: text('setCountKey'),
        paintingKey: text('paintingKey'),
        paintsKey: text('paintsKey')
      }, mode, paintingCode, variant);
    }

    function individualCartItem(map) {
      var variant = individualVariantFor(totalPots(map));
      if (!variant) return null;
      return { id: variant.id, quantity: 1, properties: paintProperties(map, 'colors', '', variant) };
    }

    function setCartItem(painting) {
      var tier = setTierFor(painting.colors.length);
      if (!tier || !tier.id) return null;
      var properties = paintProperties(new Map(), 'set', painting.code, tier);
      properties._pbn_set_tier = tier.limit;
      return { id: tier.id, quantity: 1, properties: properties };
    }

    function updateVisibleCartCount() {
      var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(rootUrl + 'cart.js', { credentials: 'same-origin' }).then(function (response) { return response.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-count, .cart-item-count, [data-cart-count], .header__cart-count, [data-cart-settings="count"] [data-count]').forEach(function (element) {
          element.textContent = cart.item_count;
        });
      }).catch(function () {});
    }

    function refreshAndOpenCart() {
      try {
        if (typeof BoosterTheme !== 'undefined' && BoosterTheme.cart) {
          return Promise.resolve(BoosterTheme.cart.dispatchListeners({ change: true })).then(function () {
            BoosterTheme.cart.open();
          });
        }
      } catch (error) {
        console.warn('[PBN paint picker] theme cart drawer unavailable', error);
      }

      updateVisibleCartCount();
      var minicartInput = Array.from(document.querySelectorAll('[data-minicart-input]')).find(function (input) {
        var label = input.parentElement && input.parentElement.querySelector('.minicart__label');
        return label && label.getClientRects().length;
      });
      if (minicartInput && !minicartInput.checked) {
        minicartInput.checked = true;
        minicartInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return Promise.resolve();
    }

    function addToCart(map, mode, paintingCode, button) {
      var total = totalPots(map);
      var setItem = mode === 'set' && activePainting ? setCartItem(activePainting) : null;
      var individualItem = mode === 'colors' ? individualCartItem(map) : null;
      if (!total || (mode === 'colors' && !individualItem) || (mode === 'set' && !setItem)) {
        setStatus(text(mode === 'set' ? 'setProductMissing' : 'priceVariantMissing'), true);
        return;
      }
      var items = mode === 'set' ? [setItem] : [individualItem];
      var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      button.disabled = true;
      button.textContent = text('adding');
      setStatus('', false);
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (payload) { throw new Error(payload.description || 'HTTP ' + response.status); });
        return response.json();
      }).then(function () {
        setStatus(text('added'), false);
        if (mode === 'colors') {
          selected.clear();
          renderSelected();
          updatePaletteSelection();
        }
        return refreshAndOpenCart();
      }).catch(function (error) {
        console.error('[PBN paint picker] cart add failed', error);
        setStatus(text('cartError'), true);
      }).finally(function () {
        button.textContent = text(mode === 'set' ? 'addSet' : 'addColors');
        var currentTotal = mode === 'colors' ? totalPots(selected) : total;
        button.disabled = mode === 'set'
          ? !activePainting || !setTierFor(currentTotal) || !setTierFor(currentTotal).id
          : currentTotal === 0 || !individualVariantFor(currentTotal);
      });
    }

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-pbn-tab]');
      if (tab) {
        var name = tab.dataset.pbnTab;
        setStatus('', false);
        root.querySelectorAll('[data-pbn-tab]').forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        root.querySelectorAll('[data-pbn-panel]').forEach(function (panel) { panel.hidden = panel.dataset.pbnPanel !== name; });
        if (name === 'set') loadPaintings().catch(function () {});
        return;
      }

      var filter = event.target.closest('[data-pbn-family]');
      if (filter) {
        activeFamily = filter.dataset.pbnFamily;
        root.querySelectorAll('[data-pbn-family]').forEach(function (item) { item.setAttribute('aria-pressed', String(item === filter)); });
        renderPalette();
        root.querySelector('[data-pbn-color-grid]').scrollTop = 0;
        return;
      }

      var swatch = event.target.closest('[data-pbn-color]');
      if (swatch) {
        setStatus('', false);
        setSwatchTabStop(swatch);
        var code = swatch.dataset.pbnColor;
        if (selected.has(code)) selected.delete(code);
        else if (totalPots(selected) >= maxIndividualPots) {
          setStatus(text('maxPots', { count: maxIndividualPots }), true);
          return;
        } else selected.set(code, 1);
        updatePaletteSelection(code);
        renderSelected();
        return;
      }

      var quantityButton = event.target.closest('[data-pbn-quantity]');
      if (quantityButton) {
        setStatus('', false);
        var quantityCode = quantityButton.dataset.pbnCode;
        var quantityAction = quantityButton.dataset.pbnQuantity;
        var quantity = selected.get(quantityCode) || 1;
        if (quantityAction === 'plus' && totalPots(selected) >= maxIndividualPots) {
          setStatus(text('maxPots', { count: maxIndividualPots }), true);
          return;
        }
        quantity += quantityAction === 'plus' ? 1 : -1;
        if (quantity < 1) selected.delete(quantityCode); else selected.set(quantityCode, quantity);
        updatePaletteSelection(quantityCode);
        renderSelected();
        var nextQuantityButton = root.querySelector('[data-pbn-quantity="' + quantityAction + '"][data-pbn-code="' + quantityCode + '"]');
        var sourceSwatch = Array.from(root.querySelectorAll('[data-pbn-color]')).find(function (item) { return item.dataset.pbnColor === quantityCode; });
        if (nextQuantityButton) nextQuantityButton.focus();
        else if (sourceSwatch) {
          setSwatchTabStop(sourceSwatch);
          sourceSwatch.focus();
        }
        else root.querySelector('[data-pbn-search]').focus();
        return;
      }

      if (event.target.closest('[data-pbn-clear-selection]')) {
        setStatus('', false);
        selected.clear();
        renderSelected();
        updatePaletteSelection();
        return;
      }

      if (event.target.closest('[data-pbn-clear-search]')) {
        searchTerm = '';
        root.querySelector('[data-pbn-search]').value = '';
        renderPalette();
        return;
      }

      var paintingOption = event.target.closest('[data-pbn-painting-option]');
      if (paintingOption) {
        selectPaintingOption(paintingOption.dataset.pbnPaintingOption);
        return;
      }

      var addColors = event.target.closest('[data-pbn-add-colors]');
      if (addColors) {
        addToCart(selected, 'colors', '', addColors);
        return;
      }

      var addSet = event.target.closest('[data-pbn-add-set]');
      if (addSet && activePainting) {
        var setMap = new Map(activePainting.colors.map(function (code) { return [code, 1]; }));
        addToCart(setMap, 'set', activePainting.code, addSet);
      }
    });

    root.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-pbn-tab]');
      if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        var tabs = Array.from(root.querySelectorAll('[data-pbn-tab]'));
        var tabIndex = tabs.indexOf(tab);
        if (event.key === 'ArrowLeft') tabIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') tabIndex = (tabIndex + 1) % tabs.length;
        if (event.key === 'Home') tabIndex = 0;
        if (event.key === 'End') tabIndex = tabs.length - 1;
        event.preventDefault();
        tabs[tabIndex].focus();
        tabs[tabIndex].click();
        return;
      }

      var swatch = event.target.closest('[data-pbn-color]');
      if (swatch && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) {
        var swatches = Array.from(root.querySelectorAll('[data-pbn-color]'));
        var swatchIndex = swatches.indexOf(swatch);
        var grid = root.querySelector('[data-pbn-color-grid]');
        var columns = Math.max(1, window.getComputedStyle(grid).gridTemplateColumns.split(' ').length);
        if (event.key === 'ArrowLeft') swatchIndex = Math.max(0, swatchIndex - 1);
        if (event.key === 'ArrowRight') swatchIndex = Math.min(swatches.length - 1, swatchIndex + 1);
        if (event.key === 'ArrowUp') swatchIndex = Math.max(0, swatchIndex - columns);
        if (event.key === 'ArrowDown') swatchIndex = Math.min(swatches.length - 1, swatchIndex + columns);
        if (event.key === 'Home') swatchIndex = 0;
        if (event.key === 'End') swatchIndex = swatches.length - 1;
        event.preventDefault();
        setSwatchTabStop(swatches[swatchIndex]);
        swatches[swatchIndex].focus();
        return;
      }

      var paintingInput = event.target.closest('[data-pbn-painting-search]');
      if (!paintingInput || !['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(event.key)) return;
      var options = suggestionOptions();
      if (event.key === 'Escape') {
        hideSuggestions();
        return;
      }
      if (!options.length) return;
      if (event.key === 'ArrowDown') setActiveSuggestion(activeSuggestionIndex < options.length - 1 ? activeSuggestionIndex + 1 : 0);
      if (event.key === 'ArrowUp') setActiveSuggestion(activeSuggestionIndex > 0 ? activeSuggestionIndex - 1 : options.length - 1);
      if (event.key === 'Enter' && activeSuggestionIndex >= 0) selectPaintingOption(options[activeSuggestionIndex].dataset.pbnPaintingOption);
      event.preventDefault();
    });

    root.querySelector('[data-pbn-search]').addEventListener('input', function (event) {
      searchTerm = event.target.value;
      renderPalette();
      root.querySelector('[data-pbn-color-grid]').scrollTop = 0;
    });

    root.querySelector('[data-pbn-painting-search]').addEventListener('input', function (event) {
      setStatus('', false);
      loadPaintings().then(function () {
        var suggestionCount = renderSuggestions(event.target.value);
        var painting = findPainting(event.target.value);
        if (painting) renderPainting(painting);
        else {
          renderPainting(null);
          root.querySelector('[data-pbn-set-empty]').textContent = normalize(event.target.value).length >= 3 && suggestionCount === 0 ? text('noPainting') : text('setEmpty');
        }
      }).catch(function () {});
    });

    root.querySelector('[data-pbn-painting-search]').addEventListener('blur', function () {
      window.setTimeout(function () {
        hideSuggestions();
      }, 160);
    });

    applyLanguage();
    renderSelected();

    var requestedPainting = '';
    try {
      requestedPainting = new URLSearchParams(window.location.search).get('painting') || '';
    } catch (error) {}
    if (requestedPainting) {
      root.querySelector('[data-pbn-painting-search]').value = requestedPainting;
      var requestedSetTab = root.querySelector('[data-pbn-tab="set"]');
      if (requestedSetTab) requestedSetTab.click();
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          loadPalette().catch(function () {});
        }
      }, { rootMargin: '300px 0px' });
      observer.observe(root);
    } else {
      loadPalette().catch(function () {});
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      buildLineItemProperties: buildLineItemProperties,
      canonicalDigits: canonicalDigits,
      paintCodeParts: paintCodeParts,
      paintSearchScore: paintSearchScore,
      normalizePaintingCode: normalizePaintingCode,
      normalizePaintingText: normalizePaintingText
    };
  }

  if (typeof document === 'undefined') return;

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pbn-paint-picker]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
